import { Dialog, DialogContent } from '@mui/material';
import { PopupTransition } from 'components/@extended/Transitions';
import { ReactNode } from 'react';

interface Props {
  open: boolean;
  handleClose: () => void;
  content: ReactNode;
}

export default function Alert({ open, handleClose, content }: Props) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{ zIndex: 9998 }}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="order-placed-title"
      aria-describedby="order-placed-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>{content}</DialogContent>
    </Dialog>
  );
}
